module.exports = __webpack_public_path__ + "img/mind_background_3.cf708254.png";